import React from 'react';
import { useParams } from 'react-router-dom';
import { CampusResources } from './CampusResources';

export function CampusResourcesPage() {
  const { organizationId } = useParams<{ organizationId: string }>();
  return <CampusResources organizationId={Number(organizationId)} />;
}
